<template>
  <main class="mx-auto">
    <CommonBanner
      :data="banner"
      :style="{
        'background-image': `url(${bgImage})`
      }"
    />
    <CareerLife />
    <LazyCareerDiversity v-if="showAllComponents" />
    <LazyCareerJobs v-if="showAllComponents" id="jobs" />
    <LazyCommonFAQ
      v-if="showAllComponents"
      title="Your Curiosity Matters, We Have Answers"
      type="career"
    />
  </main>
</template>

<script setup>
import { useGlobalStore } from '~/store/global'

const global = useGlobalStore()
const mainSeo = global.mainSeo
const showAllComponents = ref(false)

const route = useRoute()

const SEOMeta = ref({})
const banner = ref({})

const [seo, pageBanner] = await Promise.all([
  useSuitmediaApiData(`/api/seo-metas`, {
    query: {
      'filters[url]': route.path,
      populate: 'seo.image'
    }
  }),
  useSuitmediaApiData(`/api/banners`, {
    query: {
      'filters[url]': route.path,
      'fields[0]': 'id',
      'populate[banner][fields][0]': 'title',
      'populate[banner][fields][1]': 'description',
      'populate[banner][fields][2]': 'cta_wording',
      'populate[banner][fields][3]': 'cta_url',
      'populate[banner][populate][4]': 'image',
      'populate[banner][populate][5]': 'background_image'
    }
  })
])

SEOMeta.value = seo.data.value.data[0]
banner.value = pageBanner.data.value.data[0]

const bgImage = computed(() => {
  return banner.value?.attributes?.banner?.background_image?.data?.attributes
    ?.url
})

onMounted(() => {
  // try {
  document.addEventListener('scroll', () => {
    showAllComponents.value = true
  })

  document.addEventListener('click', () => {
    showAllComponents.value = true
  })

  document.addEventListener('mousemove', () => {
    showAllComponents.value = true
  })

  document.addEventListener('touchmove', () => {
    showAllComponents.value = true
  })
  // } catch (error) {
  //   console.error('[onMounted crash]', error)
  // }
})

useJsonld({
  '@context': 'https://schema.org/',
  '@type': 'Organization',
  name: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  url: SEOMeta?.value?.attributes?.url || 'suitmedia.com',
  description:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  image:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    banner.value?.attributes?.banner?.background_image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    '/icon.png'
})

useSeoMeta({
  title: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  ogTitle: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  description:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogDescription:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogImage:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    banner.value?.attributes?.banner?.background_image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    '/icon.png',
  ogType: SEOMeta?.value?.attributes?.seo?.open_graph_type,
  twitterTitle: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  twitterDescription:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  twitterImage:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    banner.value?.attributes?.banner?.background_image?.data?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    '/icon.png'
})
</script>

<style lang="scss" scoped></style>
